import React, { useContext, useEffect, useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Switch from '@mui/material/Switch';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Checkbox from '@mui/material/Checkbox';
import AccordionDetails from '@mui/material/AccordionDetails';
import ManageSpocTable from "../../components/manageSpocTable/manageSpocTable";
import './manageSpoc.css';
import { addSpoc } from "../../apis/organisationAdminAPI/manageSpoc";
import { updateSpoc } from "../../apis/organisationAdminAPI/manageSpoc";
import { getSPOCByOrg } from "../../apis/organisationAdminAPI/manageSpoc";
import { NotificationManager } from "react-notifications";
import Autocomplete from "@mui/material/Autocomplete";
import { getClientByOrg } from "../../apis/organisationAdminAPI/manageClient";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useLocation } from "react-router-dom";
import { UserTypeContext } from "../../AppRoute";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import getAllplacementTypeTemplate from "../../apis/placementTypeTemplate/getAllPlacementTemplates";
import getAllCandidateSubmissionField from "../../apis/candidateSubmissionField/getcandidateSubmissionField";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import regexEmail from "../../utilities/validateEmail"
import Tooltip from '@mui/material/Tooltip';
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";

const ManageSpoc = (props) => {
    const { userType, userRecords } = useContext(UserTypeContext);
    const location = useLocation();
    const userRecruitmentpartnerId = userType === "Admin" ? location?.state?.recruitmentPartnerId : userRecords?.recruitmentpartnerId;
    const idContextTest = userType === "Admin" ? location?.state?.id : userRecords?.id;
    const userRole = userType === "Admin" ? location?.state?.userRole : userRecords?.role?.roleName;
    const userRecordData = userType === "Admin" ? location?.state?.userRecords : userRecords;
    const history = useNavigate();
    const [emailError, setEmailError] = useState('');
    const [templateError, setTemplateError] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [editedRow, setEditedRow] = useState({});
    const [spocs, setSpocs] = useState([]);
    const [isloading, setIsloading] = useState(false);
    const [clientData, setClientData] = useState([]);
    const [spocInfo, setSpocInfo] = useState({
        name: "",
        client: "",
        email: "",
        address: "",
        active: { name: "True", value: true }
    });
    const [isUserDataUpdating, setIsUserDataUpdating] = useState(false);

    // Change tracking states
    const [hasChanges, setHasChanges] = useState(false);
    const [originalSpocInfo, setOriginalSpocInfo] = useState({});
    const [originalSendMailOn, setOriginalSendMailOn] = useState(false);
    const [originalPermanentChecked, setOriginalPermanentChecked] = useState(false);
    const [originalContractChecked, setOriginalContractChecked] = useState(false);
    const [originalPermanentCheckedItems, setOriginalPermanentCheckedItems] = useState({});
    const [originalContractCheckedItems, setOriginalContractCheckedItems] = useState({});

    const activeDropDown = [
        { name: "True", value: true },
        { name: "False", value: false },
    ];

    const [placementTemplates, setPlacementTemplates] = useState({});

    const [sendMailOn, setSendMailOn] = useState(false);
    const [placementTypeOption, setPlacementTypeOption] = useState([]);
    const [candidateSubmissionFieldData, setCandidateSubmissionFieldData] = useState([]);
    const [permanentChecked, setPermanentChecked] = useState(false);
    const [contractChecked, setContractChecked] = useState(false);
    const [permanentSelectAll, setPermanentSelectAll] = useState(false);
    const [contractSelectAll, setContractSelectAll] = useState(false);
    const [permanentCheckedItems, setPermanentCheckedItems] = useState({});
    const [contractCheckedItems, setContractCheckedItems] = useState({});
    const [loadingCheckboxes, setLoadingCheckboxes] = useState(false);
    const [permanentCheckedItemsOption, setPermanentCheckedItemsOption] = useState({});
    const [contractCheckedItemsOption, setContractCheckedItemsOption] = useState({});

    // Store the original SPOC field configurations for reactivation
    const [originalSpocPermanentFields, setOriginalSpocPermanentFields] = useState({});
    const [originalSpocContractFields, setOriginalSpocContractFields] = useState({});

    const checkForChanges = () => {

        if (Object.keys(editedRow).length === 0) {
            return { hasBasicChanges: false, hasConfigChanges: false };
        }


        const basicInfoChanged = (
            spocInfo.name !== originalSpocInfo.name ||
            spocInfo.client?._id !== originalSpocInfo.client?._id ||
            spocInfo.email !== originalSpocInfo.email ||
            spocInfo.address !== originalSpocInfo.address ||
            spocInfo.active.value !== originalSpocInfo.active.value
        );

        const configChanged = (
            sendMailOn !== originalSendMailOn ||
            permanentChecked !== originalPermanentChecked ||
            contractChecked !== originalContractChecked ||
            JSON.stringify(permanentCheckedItems) !== JSON.stringify(originalPermanentCheckedItems) ||
            JSON.stringify(contractCheckedItems) !== JSON.stringify(originalContractCheckedItems)
        );

        return {
            hasBasicChanges: basicInfoChanged,
            hasConfigChanges: configChanged
        };
    };



    useEffect(() => {
        if (Object.keys(editedRow).length > 0) {
            const { hasBasicChanges, hasConfigChanges } = checkForChanges();
            setHasChanges(hasBasicChanges || hasConfigChanges);
        }
    }, [
        spocInfo,
        sendMailOn,
        permanentChecked,
        contractChecked,
        permanentCheckedItems,
        contractCheckedItems,
        originalSpocInfo,
        originalSendMailOn,
        originalPermanentChecked,
        originalContractChecked,
        originalPermanentCheckedItems,
        originalContractCheckedItems,
        editedRow
    ]);


    const getSpocs = async () => {
        setIsloading(true);
        try {
            const response = await getSPOCByOrg({
                recruitmentPartnerId: userRecruitmentpartnerId
            });
            if (response.status === 200) {
                setSpocs(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching SPOCs:", error);
        } finally {
            setIsloading(false);
        }
    };

    const allClientsData = async () => {
        try {
            const response = await getClientByOrg({
                recruitmentPartnerId: userRecruitmentpartnerId,
                isActive: true
            });
            if (response.status === 200) {
                setClientData(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching clients:", error);
            setClientData([]);
        }
    };

    const getPlacementTemplates = async () => {
        try {
            const response = await getAllplacementTypeTemplate();
            const templates = response?.data?.data || [];
            setPlacementTypeOption(templates);

            const templateMapping = {};
            templates.forEach(template => {
                if (template.name.toLowerCase().includes('permanent')) {
                    templateMapping.permanent = template.placementTemplateCode;
                } else if (template.name.toLowerCase().includes('contract')) {
                    templateMapping.contract = template.placementTemplateCode;
                }
            });
            setPlacementTemplates(templateMapping);

            return templateMapping;
        } catch (error) {
            console.error("Error fetching placement templates:", error);
            return {};
        }
    };

    const getAllCandidateSubmissionFieldData = async () => {
        try {
            setLoadingCheckboxes(true);
            const response = await getAllCandidateSubmissionField();
            setCandidateSubmissionFieldData(response?.data?.data || []);
            return response?.data?.data || [];
        } catch (error) {
            console.error("Error fetching candidate fields:", error);
            return [];
        } finally {
            setLoadingCheckboxes(false);
        }
    };

    const setCheckboxStatesFromSpocConfig = async (rowData) => {
        try {
            setLoadingCheckboxes(true);

            let templates = placementTemplates;
            if (Object.keys(templates).length === 0) {
                templates = await getPlacementTemplates();
            }

            let fields = candidateSubmissionFieldData;
            if (fields.length === 0) {
                fields = await getAllCandidateSubmissionFieldData();
            }


            const initialPermChecked = {};
            const initialContractChecked = {};
            const spocOriginalPermFields = {};
            const spocOriginalContractFields = {};

            const permFields = fields.filter(f =>
                f.placementTemplateCode.includes(templates.permanent) && f.isActive
            );
            const contractFields = fields.filter(f =>
                f.placementTemplateCode.includes(templates.contract) && f.isActive
            );

            permFields.forEach(field => {
                initialPermChecked[field._id] = false;
            });

            contractFields.forEach(field => {
                initialContractChecked[field._id] = false;
            });

            let hasPermanent = false;
            let hasContract = false;

            if (rowData.spocSubmissionConfigs?.length > 0) {
                for (const config of rowData.spocSubmissionConfigs) {
                    // Process permanent configs (both active and inactive to allow reactivation)
                    if (config.placementTemplateCode === templates.permanent) {
                        // Only set hasPermanent to true if config is currently active
                        if (config.isActive) {
                            hasPermanent = true;
                        }

                        // Always restore the saved field data regardless of active status
                        for (const savedField of config.submissionField) {
                            const matchingField = fields.find(f =>
                                f.submissionCode === savedField.submissionCode &&
                                f.placementTemplateCode.includes(templates.permanent) &&
                                f.isActive
                            );
                            if (matchingField) {
                                initialPermChecked[matchingField._id] = savedField.isFieldActive;
                                spocOriginalPermFields[matchingField._id] = savedField.isFieldActive;
                            }
                        }
                    }

                    // Process contract configs (both active and inactive to allow reactivation)
                    if (config.placementTemplateCode === templates.contract) {
                        if (config.isActive) {
                            hasContract = true;
                        }

                        for (const savedField of config.submissionField) {
                            const matchingField = fields.find(f =>
                                f.submissionCode === savedField.submissionCode &&
                                f.placementTemplateCode.includes(templates.contract) &&
                                f.isActive
                            );
                            if (matchingField) {
                                initialContractChecked[matchingField._id] = savedField.isFieldActive;
                                spocOriginalContractFields[matchingField._id] = savedField.isFieldActive;
                            }
                        }
                    }
                }
            }

            setPermanentChecked(hasPermanent);
            setContractChecked(hasContract);
            // Don't set setSendMailOn here - it should be set based on isEmailRequired in edit mode
            setPermanentCheckedItems(initialPermChecked);
            setContractCheckedItems(initialContractChecked);

            // Store the original SPOC field configurations
            setOriginalSpocPermanentFields(spocOriginalPermFields);
            setOriginalSpocContractFields(spocOriginalContractFields);

            // Set select-all states
            const allPermSelected = permFields.length > 0 &&
                permFields.every(f => initialPermChecked[f._id]);
            const allContractSelected = contractFields.length > 0 &&
                contractFields.every(f => initialContractChecked[f._id]);

            setPermanentSelectAll(allPermSelected);
            setContractSelectAll(allContractSelected);

            // Return the initial values to be used in edit dialog
            return {
                initialPermChecked,
                initialContractChecked,
                hasPermanent,
                hasContract
            };

        } catch (error) {
            console.error("Error setting checkbox states:", error);
        } finally {
            setLoadingCheckboxes(false);
        }
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
        setEditedRow({});
        setHasChanges(false);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setEditedRow({});
        setSpocInfo({
            name: "",
            client: "",
            email: "",
            address: "",
            active: { name: "True", value: true }
        });
        setPermanentChecked(false);
        setContractChecked(false);
        setSendMailOn(false);
        setPermanentCheckedItems({});
        setContractCheckedItems({});
        setPermanentSelectAll(false);
        setContractSelectAll(false);
        setEmailError("");
        setTemplateError("");

        // Reset change tracking
        setHasChanges(false);
        setOriginalSpocInfo({});
        setOriginalSendMailOn(false);
        setOriginalPermanentChecked(false);
        setOriginalContractChecked(false);
        setOriginalPermanentCheckedItems({});
        setOriginalContractCheckedItems({});
        setOriginalSpocPermanentFields({});
        setOriginalSpocContractFields({});
    };

    const handleOpenEditDialog = async (rowData) => {
        const initialSpocInfo = {
            name: rowData.spocName,
            client: rowData.client[0],
            email: rowData.spocEmail,
            address: rowData.address,
            active: {
                name: rowData.isActive ? "True" : "False",
                value: rowData.isActive
            }
        };

        setSpocInfo(initialSpocInfo);
        setOriginalSpocInfo(initialSpocInfo);
        setEditedRow(rowData);
        setOpenDialog(true);
        setHasChanges(false);

        setSendMailOn(rowData.isEmailRequired || false);

        try {
            // Only fetch if not already loaded
            let templates = placementTemplates;
            let fields = candidateSubmissionFieldData;
            if (Object.keys(templates).length === 0) {
                templates = await getPlacementTemplates();
            }
            if (fields.length === 0) {
                fields = await getAllCandidateSubmissionFieldData();
            }

            const selectedClient = clientData.find(client => client._id === rowData.client[0]._id);
            let clientConfigs = selectedClient?.clientSubmissionConfigs;

            if (!clientConfigs) {
                clientConfigs = [];
            } else if (!Array.isArray(clientConfigs)) {
                clientConfigs = [clientConfigs];
            } else if (Array.isArray(clientConfigs) && clientConfigs.length > 0 && Array.isArray(clientConfigs[0])) {
                clientConfigs = clientConfigs[0];
            }

            const newPermCheckedOption = {};
            const newContractCheckedOption = {};

            clientConfigs.forEach(config => {
                if (config.placementTemplateCode === templates.permanent && config.isActive) {
                    config.submissionField.forEach(configField => {
                        const matchingField = fields.find(f =>
                            f.submissionCode === configField.submissionCode &&
                            f.placementTemplateCode.includes(templates.permanent) &&
                            f.isActive
                        );
                        if (matchingField) {
                            newPermCheckedOption[matchingField._id] = configField.isFieldActive;
                        }
                    });
                }

                if (config.placementTemplateCode === templates.contract && config.isActive) {
                    config.submissionField.forEach(configField => {
                        const matchingField = fields.find(f =>
                            f.submissionCode === configField.submissionCode &&
                            f.placementTemplateCode.includes(templates.contract) &&
                            f.isActive
                        );
                        if (matchingField) {
                            newContractCheckedOption[matchingField._id] = configField.isFieldActive;
                        }
                    });
                }
            });

            setPermanentCheckedItemsOption(newPermCheckedOption);
            setContractCheckedItemsOption(newContractCheckedOption);

            const checkboxResult = await setCheckboxStatesFromSpocConfig(rowData);

            const originalSendMail = rowData.isEmailRequired || false;
            const originalHasPermanent = rowData.spocSubmissionConfigs?.some(
                config => config.placementTemplateCode === templates.permanent
            ) || false;
            const originalHasContract = rowData.spocSubmissionConfigs?.some(
                config => config.placementTemplateCode === templates.contract
            ) || false;

            setOriginalSendMailOn(originalSendMail);
            setOriginalPermanentChecked(originalHasPermanent);
            setOriginalContractChecked(originalHasContract);

            // Set original checked items using the values from setCheckboxStatesFromSpocConfig
            if (checkboxResult) {
                setOriginalPermanentCheckedItems({ ...checkboxResult.initialPermChecked });
                setOriginalContractCheckedItems({ ...checkboxResult.initialContractChecked });
            }

        } catch (error) {
            console.error("Error initializing edit mode:", error);
        }
    };

    const handlePlacementTypeCheckboxChange = (event, type) => {
        const checked = event.target.checked;
        if (type.placementTemplateCode === placementTemplates.permanent) {
            setPermanentChecked(checked);
            if (!checked) {
                setPermanentCheckedItems(prev => {
                    const updated = {};
                    Object.keys(prev).forEach(id => {
                        updated[id] = false;
                    });
                    return updated;
                });
                setPermanentSelectAll(false);
            } else {
                // When reactivating, restore the original SPOC config data if available
                // Otherwise fall back to client config
                const fieldsToRestore = Object.keys(originalSpocPermanentFields).length > 0
                    ? originalSpocPermanentFields
                    : permanentCheckedItemsOption;

                setPermanentCheckedItems(fieldsToRestore);

                // Check if all items should be selected based on the restored fields
                const permFields = candidateSubmissionFieldData.filter(f =>
                    f.placementTemplateCode.includes(placementTemplates.permanent) && f.isActive
                );
                const allSelected = permFields.every(f => fieldsToRestore[f._id]);
                setPermanentSelectAll(allSelected);
            }
        } else if (type.placementTemplateCode === placementTemplates.contract) {
            setContractChecked(checked);
            if (!checked) {
                // Only clear when unchecking
                setContractCheckedItems(prev => {
                    const updated = {};
                    Object.keys(prev).forEach(id => {
                        updated[id] = false;
                    });
                    return updated;
                });
                setContractSelectAll(false);
            } else {
                // When reactivating, restore the original SPOC config data if available
                // Otherwise fall back to client config
                const fieldsToRestore = Object.keys(originalSpocContractFields).length > 0
                    ? originalSpocContractFields
                    : contractCheckedItemsOption;

                setContractCheckedItems(fieldsToRestore);

                // Check if all items should be selected based on the restored fields
                const contractFields = candidateSubmissionFieldData.filter(f =>
                    f.placementTemplateCode.includes(placementTemplates.contract) && f.isActive
                );
                const allSelected = contractFields.every(f => fieldsToRestore[f._id]);
                setContractSelectAll(allSelected);
            }
        }
    };

    const handlePermanentSelectAllChange = (e) => {
        const checked = e.target.checked;
        setPermanentSelectAll(checked);

        setPermanentCheckedItems(prev => {
            const updated = { ...prev };

            const permFields = candidateSubmissionFieldData.filter(f =>
                f.placementTemplateCode.includes(placementTemplates.permanent) && f.isActive
            );

            permFields.forEach(field => {
                const isFieldEnabled = permanentCheckedItemsOption[field._id] === true;
                if (isFieldEnabled) {
                    updated[field._id] = checked;
                }
            });

            return updated;
        });
    };

    const handleContractSelectAllChange = (e) => {
        const checked = e.target.checked;
        setContractSelectAll(checked);

        setContractCheckedItems(prev => {
            const updated = { ...prev };

            const contractFields = candidateSubmissionFieldData.filter(f =>
                f.placementTemplateCode.includes(placementTemplates.contract) && f.isActive
            );

            contractFields.forEach(field => {
                const isFieldEnabled = contractCheckedItemsOption[field._id] === true;
                if (isFieldEnabled) {
                    updated[field._id] = checked;
                }
            });

            return updated;
        });
    };

    const handlePermanentItemChange = (id) => (e) => {
        const checked = e.target.checked;
        setPermanentCheckedItems(prev => {
            const updated = { ...prev, [id]: checked };

            // Update select all state based on enabled fields only
            const permFields = candidateSubmissionFieldData.filter(f =>
                f.placementTemplateCode.includes(placementTemplates.permanent) && f.isActive
            );
            const enabledPermFields = permFields.filter(f => permanentCheckedItemsOption[f._id] === true);
            const allEnabledChecked = enabledPermFields.length > 0 &&
                enabledPermFields.every(f => updated[f._id]);
            setPermanentSelectAll(allEnabledChecked);

            return updated;
        });
    };

    const handleContractItemChange = (id) => (e) => {
        const checked = e.target.checked;
        setContractCheckedItems(prev => {
            const updated = { ...prev, [id]: checked };

            // Update select all state based on enabled fields only
            const contractFields = candidateSubmissionFieldData.filter(f =>
                f.placementTemplateCode.includes(placementTemplates.contract) && f.isActive
            );
            const enabledContractFields = contractFields.filter(f => contractCheckedItemsOption[f._id] === true);
            const allEnabledChecked = enabledContractFields.length > 0 &&
                enabledContractFields.every(f => updated[f._id]);
            setContractSelectAll(allEnabledChecked);

            return updated;
        });
    };

    const hasPlacementTemplateData = (placementTemplateCode) => {
        if (!spocInfo.client) return false;

        // Get client config from local data
        const selectedClient = clientData.find(c => c._id === spocInfo.client._id);
        let clientConfigs = selectedClient?.clientSubmissionConfigs;

        // Handle different data structures
        if (!clientConfigs) {
            clientConfigs = [];
        } else if (!Array.isArray(clientConfigs)) {
            // If it's a single object, convert to array
            clientConfigs = [clientConfigs];
        } else if (Array.isArray(clientConfigs) && clientConfigs.length > 0 && Array.isArray(clientConfigs[0])) {
            // If it's nested array, flatten it
            clientConfigs = clientConfigs[0];
        }

        // Check if client has active config for this template
        const hasClientConfig = clientConfigs.some(
            config => config.placementTemplateCode === placementTemplateCode && config.isActive
        );

        // Check if there are any candidate submission fields for this template
        const fieldsForTemplate = candidateSubmissionFieldData.filter(
            field => field.placementTemplateCode.includes(placementTemplateCode) && field.isActive
        );

        return hasClientConfig && fieldsForTemplate.length > 0;
    };

    const handleNameChange = (e) => {
        setSpocInfo({ ...spocInfo, name: e.target.value });
    };

    const handleClientChange = async (e, value) => {
        setSpocInfo({ ...spocInfo, client: value });

        // Reset states
        setPermanentChecked(false);
        setContractChecked(false);
        setPermanentCheckedItems({});
        setContractCheckedItems({});
        setPermanentSelectAll(false);
        setContractSelectAll(false);

        if (!value?._id) {
            setSendMailOn(false);
            return;
        }

        // Set sendMailOn based on client's email requirement
        setSendMailOn(value.isEmailRequired);

        if (!value.isEmailRequired) return;

        try {
            setLoadingCheckboxes(true);

            // Get client config from local data
            const selectedClient = clientData.find(client => client._id === value._id);
            let clientConfigs = selectedClient?.clientSubmissionConfigs;



            // Handle different data structures
            if (!clientConfigs) {
                clientConfigs = [];
            } else if (!Array.isArray(clientConfigs)) {
                // If it's a single object, convert to array
                clientConfigs = [clientConfigs];
            } else if (Array.isArray(clientConfigs) && clientConfigs.length > 0 && Array.isArray(clientConfigs[0])) {
                // If it's nested array, flatten it
                clientConfigs = clientConfigs[0];
            }


            // Get placement templates if not loaded
            let templates = placementTemplates;
            if (Object.keys(templates).length === 0) {
                templates = await getPlacementTemplates();
            }

            // Get candidate fields if not loaded
            let fields = candidateSubmissionFieldData;
            if (fields.length === 0) {
                fields = await getAllCandidateSubmissionFieldData();
            }

            // Initialize checkbox states
            const newPermChecked = {};
            const newContractChecked = {};
            const newPermCheckedOption = {};
            const newContractCheckedOption = {};

            let hasPermanent = false;
            let hasContract = false;

            // Process client configs array
            clientConfigs.forEach(config => {
                if (config.placementTemplateCode === templates.permanent && config.isActive) {
                    hasPermanent = true;
                    config.submissionField.forEach(configField => {
                        // Find matching field by submissionCode
                        const matchingField = fields.find(f =>
                            f.submissionCode === configField.submissionCode &&
                            f.placementTemplateCode.includes(templates.permanent) &&
                            f.isActive
                        );
                        if (matchingField) {
                            newPermCheckedOption[matchingField._id] = configField.isFieldActive;
                            newPermChecked[matchingField._id] = configField.isFieldActive;
                        }
                    });
                }

                if (config.placementTemplateCode === templates.contract && config.isActive) {
                    hasContract = true;
                    config.submissionField.forEach(configField => {

                        const matchingField = fields.find(f =>
                            f.submissionCode === configField.submissionCode &&
                            f.placementTemplateCode.includes(templates.contract) &&
                            f.isActive
                        );
                        if (matchingField) {
                            newContractCheckedOption[matchingField._id] = configField.isFieldActive;
                            newContractChecked[matchingField._id] = configField.isFieldActive;
                        }
                    });
                }
            });


            setPermanentChecked(hasPermanent);
            setContractChecked(hasContract);
            setPermanentCheckedItems(newPermChecked);
            setContractCheckedItems(newContractChecked);
            setPermanentCheckedItemsOption(newPermCheckedOption);
            setContractCheckedItemsOption(newContractCheckedOption);

            const permFields = fields.filter(f =>
                f.placementTemplateCode.includes(templates.permanent) &&
                f.isActive &&
                newPermCheckedOption[f._id]
            );
            const contractFields = fields.filter(f =>
                f.placementTemplateCode.includes(templates.contract) &&
                f.isActive &&
                newContractCheckedOption[f._id]
            );

            setPermanentSelectAll(permFields.length > 0 &&
                permFields.every(f => newPermChecked[f._id]));
            setContractSelectAll(contractFields.length > 0 &&
                contractFields.every(f => newContractChecked[f._id]));

        } catch (error) {
            console.error("Error loading client config:", error);
        } finally {
            setLoadingCheckboxes(false);
        }
    };


    const checkDisabled = (item, isPermanent) => {
        if (isPermanent) {
            return !permanentCheckedItemsOption[item._id];
        }
        return !contractCheckedItemsOption[item._id];
    };
    const handleEmailChange = (e) => {
        const emailValue = e.target.value.trim();

        setSpocInfo({ ...spocInfo, email: emailValue });

        // Validate email using imported regexEmail function
        if (emailValue === '') {
            setEmailError('Email is required');
        } else if (emailValue.length > 254) {
            setEmailError('Email is too long (maximum 254 characters)');
        } else if (!regexEmail(emailValue)) {
            setEmailError('Please enter a valid email address');
        } else {
            setEmailError('');
        }
    };

    const handleAddressChange = (e) => {
        setSpocInfo({ ...spocInfo, address: e.target.value });
    };

    const handleActiveChange = (e, value) => {
        setSpocInfo({ ...spocInfo, active: value });
    };

    const goToDashboard = () => {
        history("/dashboard", {
            state: {
                userType: userType,
                recruitmentPartnerId: userRecruitmentpartnerId,
                id: idContextTest,
                userRecords: userRecordData,
                roleName: userRole
            }
        });
    };

    const isSubmitDisabled = () => {
        if (isUserDataUpdating || loadingCheckboxes) {
            return true;
        }
        if (Object.keys(editedRow).length > 0 && !hasChanges) {
            return true;
        }
        if (Object.keys(editedRow).length === 0) {
            if (sendMailOn && !permanentChecked && !contractChecked) {
                return true;
            }
        }


        if (sendMailOn) {

            if (permanentChecked) {
                const hasSelectedPermanentFields = Object.values(permanentCheckedItems).some(isChecked => isChecked);
                if (!hasSelectedPermanentFields) {
                    return true;
                }
            }


            if (contractChecked) {
                const hasSelectedContractFields = Object.values(contractCheckedItems).some(isChecked => isChecked);
                if (!hasSelectedContractFields) {
                    return true;
                }
            }
        }

        return false;
    };


    const handleSubmit = async () => {
        if (!spocInfo.email || !regexEmail(spocInfo.email)) {
            setEmailError(
                !spocInfo.email
                    ? 'Email is required'
                    : 'Please enter a valid email address'
            );
            NotificationManager.error("Please enter a valid email address", "Error", 10000);
            return;
        }

        // Prevent submit if emailError is set
        if (emailError) {
            NotificationManager.error(emailError, "Error", 10000);
            return;
        }

        if (!spocInfo.name || !spocInfo.client || !spocInfo.email || !spocInfo.address || !spocInfo.active) {
            NotificationManager.error("Please fill in all the required fields", "Error", 10000);
            return;
        }


        if (templateError) {
            return;
        }

        try {
            const payload = {
                spocName: spocInfo.name,
                clientId: spocInfo.client._id,
                spocEmail: spocInfo.email,
                address: spocInfo.address,
                isActive: spocInfo.active.value,
                recruitmentpartnerId: userRecruitmentpartnerId,
                isEmailRequired: sendMailOn,
                spocSubmissionConfig: []
            };

            setIsUserDataUpdating(true);

            const templates = await getPlacementTemplates();
            const fields = await getAllCandidateSubmissionFieldData();
            const selectedClient = clientData.find(c => c._id === spocInfo.client._id);
            let clientConfigs = selectedClient?.clientSubmissionConfigs || [];

            if (!Array.isArray(clientConfigs)) clientConfigs = [clientConfigs];
            else if (Array.isArray(clientConfigs) && clientConfigs.length > 0 && Array.isArray(clientConfigs[0])) {
                clientConfigs = clientConfigs[0];
            }


            // In edit mode, process all templates that exist in original data OR are currently checked
            const templatesToProcess = [];
            if (Object.keys(editedRow).length > 0) {
                // Edit mode: include all templates that either exist in original data or are currently checked
                const existingTemplates = editedRow.spocSubmissionConfigs?.map(config => config.placementTemplateCode) || [];
                const currentTemplates = [];
                if (permanentChecked) currentTemplates.push(templates.permanent);
                if (contractChecked) currentTemplates.push(templates.contract);
                const allTemplates = [...new Set([...existingTemplates, ...currentTemplates])];
                templatesToProcess.push(...allTemplates);
            } else {
                if (permanentChecked) templatesToProcess.push(templates.permanent);
                if (contractChecked) templatesToProcess.push(templates.contract);
            }

            templatesToProcess.forEach(templateCode => {
                const clientConfig = clientConfigs.find(
                    config => config.placementTemplateCode === templateCode && config.isActive
                );

                if (clientConfig) {
                    const isChecked = templateCode === templates.permanent ? permanentChecked : contractChecked;
                    const checkedItems = templateCode === templates.permanent ? permanentCheckedItems : contractCheckedItems;
                    const itemsOption = templateCode === templates.permanent
                        ? permanentCheckedItemsOption
                        : contractCheckedItemsOption;

                    const templateFields = fields.filter(
                        f => f.placementTemplateCode.includes(templateCode) && f.isActive
                    );

                    const submissionFields = templateFields
                        .filter(f => itemsOption[f._id] !== undefined)
                        .map(f => {
                            let isFieldActive = true;

                            if (sendMailOn && isChecked) {
                                isFieldActive = checkedItems[f._id] || false;
                            } else if (Object.keys(editedRow).length > 0) {
                                const existingConfig = editedRow.spocSubmissionConfigs?.find(
                                    config => config.placementTemplateCode === templateCode
                                );
                                const existingField = existingConfig?.submissionField?.find(
                                    field => field.submissionCode === f.submissionCode
                                );
                                if (existingField) {
                                    isFieldActive = existingField.isFieldActive;
                                }
                            }

                            return {
                                submissionCode: f.submissionCode,
                                isFieldActive: isFieldActive
                            };
                        });

                    if (submissionFields.length > 0) {
                        const configEntry = {
                            clientSubmissionConfigId: clientConfig._id,
                            placementTemplateCode: templateCode,
                            isActive: sendMailOn && isChecked,
                            submissionField: submissionFields
                        };

                        if (Object.keys(editedRow).length > 0 && editedRow.spocSubmissionConfigs?.length > 0) {
                            const existingConfig = editedRow.spocSubmissionConfigs.find(
                                config => config.placementTemplateCode === templateCode
                            );
                            if (existingConfig && existingConfig._id) {
                                configEntry._id = existingConfig._id;
                            }
                        }

                        payload.spocSubmissionConfig.push(configEntry);
                    }
                }
            });



            const response = Object.keys(editedRow).length > 0
                ? await updateSpoc(editedRow._id, payload)
                : await addSpoc(payload);

            if (response.status === (Object.keys(editedRow).length > 0 ? 200 : 201)) {
                handleCloseDialog();
                getSpocs();
                NotificationManager.success(
                    `POC ${Object.keys(editedRow).length > 0 ? 'updated' : 'added'} successfully`,
                    "Success",
                    10000
                );
            } else {
                NotificationManager.error(response.data?.message || "Failed to process POC", "Error", 10000);
            }
        } catch (error) {
            console.error("Error:", error);
            NotificationManager.error(
                error.response?.data?.message ||
                error.response?.data?.errMessage ||
                "An error occurred",
                "Error",
                10000
            );
        } finally {
            setIsUserDataUpdating(false);
        }
    };



    useEffect(() => {
        if (sendMailOn && spocInfo.client) {
            const hasAvailableTemplates = placementTypeOption.some(type => {
                const templateCode = type.placementTemplateCode || type.code;
                return hasPlacementTemplateData(templateCode);
            });

            if (!hasAvailableTemplates) {
                setTemplateError('Please select any template. No placement template configurations are available for this client.');
            } else if (!permanentChecked && !contractChecked) {
                setTemplateError('Please select at least one placement type (Permanent or Contract).');
            } else {
                // Check if placement types are selected but no fields are chosen
                let fieldValidationError = '';

                if (permanentChecked) {
                    const hasSelectedPermanentFields = Object.values(permanentCheckedItems).some(isChecked => isChecked);
                    if (!hasSelectedPermanentFields) {
                        fieldValidationError = 'Please select at least one field for Permanent placement type.';
                    }
                }

                if (contractChecked && !fieldValidationError) {
                    const hasSelectedContractFields = Object.values(contractCheckedItems).some(isChecked => isChecked);
                    if (!hasSelectedContractFields) {
                        fieldValidationError = 'Please select at least one field for Contract placement type.';
                    }
                }

                if (permanentChecked && contractChecked && !fieldValidationError) {
                    const hasSelectedPermanentFields = Object.values(permanentCheckedItems).some(isChecked => isChecked);
                    const hasSelectedContractFields = Object.values(contractCheckedItems).some(isChecked => isChecked);
                    if (!hasSelectedPermanentFields && !hasSelectedContractFields) {
                        fieldValidationError = 'Please select at least one field for the selected placement types.';
                    }
                }

                setTemplateError(fieldValidationError);
            }
        } else {
            setTemplateError('');
        }
    }, [sendMailOn, spocInfo.client, placementTypeOption, permanentChecked, contractChecked, permanentCheckedItems, contractCheckedItems]);


    // Handle when SPOC is set to inactive in edit mode - revert to previous state
    useEffect(() => {
        if (Object.keys(editedRow).length > 0 && !spocInfo.active.value) {
            // Revert to original email submission state
            setSendMailOn(originalSendMailOn);

            // Revert to original placement type states
            setPermanentChecked(originalPermanentChecked);
            setContractChecked(originalContractChecked);

            // Revert to original field selections
            setPermanentCheckedItems(originalPermanentCheckedItems);
            setContractCheckedItems(originalContractCheckedItems);
        }
    }, [spocInfo.active.value, editedRow, originalSendMailOn, originalPermanentChecked, originalContractChecked, originalPermanentCheckedItems, originalContractCheckedItems]);

    useEffect(() => {
        if (
            userRecruitmentpartnerId &&
            (
                userType === "Organization Admin" ||
                userType === "MIS Operator" ||
                (userType === "Admin" && userRole === "Organization Admin") ||
                (userType === "Admin" && userRole === "MIS Operator")
            )
        ) {
            getSpocs();
            allClientsData();
            // Only fetch if not already loaded
            if (placementTypeOption.length === 0) getPlacementTemplates();
            if (candidateSubmissionFieldData.length === 0) getAllCandidateSubmissionFieldData();
        }
    }, [userRecruitmentpartnerId, userType]);

    return (
        <>
            {(userType === "Organization Admin" || userType === "MIS Operator" ||
                (userType === 'Admin' && userRole === 'Organization Admin') ||
                (userType === 'Admin' && userRole === 'MIS Operator')) ? (
                <>
                    <div className="manageSpoc_container">
                        <div className="manageSpoc_header_container">
                            <div className="manageSpoc_header_left">
                                <div className="manageSpoc_goBackButton" onClick={(e) => goToDashboard(e)}>
                                    <Tooltip title="Go Back to Dashboard" placement="bottom">
                                        <ArrowBackIcon sx={{ fontSize: 20 }} />
                                    </Tooltip>
                                </div>
                                <div className="manageSpoc_title">Manage POC</div>
                            </div>
                            {userType !== "Admin" && (
                                <div className="manageSpoc_header_right">
                                    <Button
                                        className="manageSpoc_addButton"
                                        onClick={handleOpenDialog}
                                        startIcon={<PersonAddAltIcon alt="Add SPOC" style={{ width: "22px", height: "22px" }} />}
                                    >
                                        Add POC
                                    </Button>
                                </div>
                            )}
                        </div>
                        <ManageSpocTable
                            spocs={spocs}
                            isloading={isloading}
                            onEdit={handleOpenEditDialog}
                            userType={userType}
                        />
                    </div>

                    <Dialog
                        open={openDialog}
                        onClose={handleCloseDialog}
                        aria-labelledby="dialog-title"
                        maxWidth="sm"
                        fullWidth={true}
                        className="add-spoc"
                    >
                        <div className="spoc_dialog_modal">
                            <div className='spoc-dialog-TitleContainer'>
                                <PersonAddAltIcon alt="Add SPOC" className="dialog-image" />
                                <span className="dialog-title-text">
                                    {Object.keys(editedRow).length > 0 ? 'Edit POC' : 'Add POC'}
                                </span>
                            </div>
                        </div>
                        <DialogContent className="spoc-dialog-content">
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12 }}>
                                    <Typography className='field-title-spoc-dialog'>POC Name*</Typography>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Enter POC Name"
                                        className='input-field-spoc-dialog'
                                        value={spocInfo.name}
                                        onChange={handleNameChange}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Typography className='field-title-spoc-dialog'>Client*</Typography>
                                    <Autocomplete
                                        value={spocInfo.client}
                                        options={clientData}
                                        getOptionLabel={(option) => option?.clientName || ""}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder="Client"
                                            />
                                        )}
                                        onChange={handleClientChange}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Typography className='field-title-spoc-dialog'>Email*</Typography>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        className='input-field-spoc-dialog'
                                        placeholder="Enter Email"
                                        value={spocInfo.email}
                                        onChange={handleEmailChange}
                                        error={!!emailError}
                                        helperText={emailError}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Typography className='field-title-spoc-dialog'>Address*</Typography>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Enter Address"
                                        value={spocInfo.address}
                                        multiline
                                        minRows={4}
                                        onChange={handleAddressChange}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Typography className='field-title-spoc-dialog'>Is Active*</Typography>
                                    <Autocomplete
                                        value={spocInfo.active}
                                        options={activeDropDown}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder="Select Active"
                                            />
                                        )}
                                        onChange={handleActiveChange}
                                    />
                                </Grid>
                                {spocInfo.client && (
                                    <>
                                        <Grid size={{ xs: 12 }}>
                                            <Typography className="field-title-client-field">
                                                Requires Email Submission
                                            </Typography>
                                            <div className="searchtoggleContainer">
                                                <Switch
                                                    checked={sendMailOn}
                                                    onChange={(event) => {
                                                        // Check if client allows email requirement (both edit and add mode)
                                                        const clientAllowsEmail = spocInfo.client?.isEmailRequired;

                                                        if (clientAllowsEmail) {
                                                            setSendMailOn(event.target.checked);
                                                        }
                                                    }}
                                                    disabled={!spocInfo.client?.isEmailRequired || (Object.keys(editedRow).length > 0 && !spocInfo.active.value)}
                                                    color="primary"
                                                />

                                                <span className="booleanText">
                                                    {sendMailOn ? "YES" : "NO"}
                                                </span>
                                            </div>
                                        </Grid>
                                        {spocInfo.client && spocInfo.client.isEmailRequired && sendMailOn && !(Object.keys(editedRow).length > 0 && !spocInfo.active.value) && (
                                            <Grid size={{ xs: 12 }}>
                                                {templateError && (
                                                    <div className="spoc-template-container">
                                                        {templateError}
                                                    </div>
                                                )}
                                                {loadingCheckboxes ? (
                                                    <div className="checkbox-loading">
                                                        <CircularProgress size={20} />
                                                        <span>Loading submission options...</span>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <Typography className="field-title-client-dialog_template">
                                                            * Please select your preferred method of template
                                                        </Typography>
                                                        <Grid size={{ xs: 12 }} className="manageclient_accordion_container">
                                                            {placementTypeOption
                                                                .filter(type => {
                                                                    const templateCode = type.placementTemplateCode || type.code;
                                                                    return hasPlacementTemplateData(templateCode);
                                                                })
                                                                .map((type) => {
                                                                    const isPermanent = type.placementTemplateCode === placementTemplates.permanent;
                                                                    const checked = isPermanent ? permanentChecked : contractChecked;
                                                                    const selectAll = isPermanent ? permanentSelectAll : contractSelectAll;
                                                                    const checkedItems = isPermanent ? permanentCheckedItems : contractCheckedItems;
                                                                    const filteredFields = candidateSubmissionFieldData.filter(
                                                                        field => field.placementTemplateCode.includes(
                                                                            type.placementTemplateCode || type.code
                                                                        ) && field.isActive
                                                                    );

                                                                    return (
                                                                        <Accordion key={type._id} expanded={checked}>
                                                                            <AccordionSummary
                                                                                expandIcon={<ExpandMoreIcon />}
                                                                                aria-controls={`panel-content`}
                                                                                id={`panel-header`}
                                                                            >
                                                                                <div className="manageclient_accordion">
                                                                                    <Checkbox
                                                                                        checked={checked}
                                                                                        onChange={(e) => handlePlacementTypeCheckboxChange(e, type)}
                                                                                        color="primary"
                                                                                        inputProps={{ "aria-label": `${type.name} checkbox` }}
                                                                                    />
                                                                                    <Typography className="manageclient_accordion_header">
                                                                                        {type.name}
                                                                                    </Typography>
                                                                                </div>
                                                                            </AccordionSummary>
                                                                            <AccordionDetails>
                                                                                <div className="client_accordion_details_container">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={selectAll}
                                                                                        onChange={
                                                                                            isPermanent
                                                                                                ? handlePermanentSelectAllChange
                                                                                                : handleContractSelectAllChange
                                                                                        }
                                                                                        style={{ transform: "scale(1.5)" }}
                                                                                    />
                                                                                    <label className="client_accordion_details_select-all">
                                                                                        Select All
                                                                                    </label>
                                                                                </div>
                                                                                <div className="client_options_accordion_container">
                                                                                    {filteredFields.map((item) => (
                                                                                        <div key={item._id} className="client_option_accordion_container">
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                checked={(isPermanent ? permanentCheckedItems : contractCheckedItems)[item._id] || false}
                                                                                                disabled={checkDisabled(item, isPermanent)}
                                                                                                onChange={
                                                                                                    isPermanent
                                                                                                        ? handlePermanentItemChange(item._id)
                                                                                                        : handleContractItemChange(item._id)
                                                                                                }
                                                                                                style={{ transform: "scale(1.5)" }}
                                                                                            />
                                                                                            <label className="client_option_accordion_label">
                                                                                                {item.name}
                                                                                            </label>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </AccordionDetails>
                                                                        </Accordion>
                                                                    );
                                                                })}

                                                            {/* Show message if no placement templates have data */}
                                                            {placementTypeOption.filter(type => {
                                                                const templateCode = type.placementTemplateCode || type.code;
                                                                return hasPlacementTemplateData(templateCode);
                                                            }).length === 0 && (
                                                                    <div className="no-placement-data">
                                                                        <Typography variant="body2" color="textSecondary">
                                                                            No placement template configurations available for this client.
                                                                        </Typography>
                                                                    </div>
                                                                )}
                                                        </Grid>
                                                    </>
                                                )}
                                            </Grid>
                                        )}
                                    </>
                                )}
                            </Grid>
                        </DialogContent>
                        <DialogActions className='dialog-actionbutton-spoc'>
                            <button onClick={handleCloseDialog} className="cancel-button-spoc">
                                Cancel
                            </button>
                            <button
                                className={
                                    isSubmitDisabled()
                                        ? 'updateButton_spoc_disabled'
                                        : 'updateButton-spoc'
                                }
                                onClick={handleSubmit}
                                disabled={isSubmitDisabled()}
                            >
                                {isUserDataUpdating ? (
                                    <>
                                        <CircularProgress className="circularProgress_updateButton_spoc" />
                                        <span>Saving...</span>
                                    </>
                                ) : (
                                    <span>Save</span>
                                )}
                            </button>
                        </DialogActions>
                    </Dialog>
                </>
            ) : (
                <UnauthorizedAccess />
            )}
        </>
    );
};

export default ManageSpoc;

